<template>
  <div class="page-events">
    <!-- 公告 -->
    <div class="notice" :class="{'notice_fixed': isBottom}" ref="notice" @click="navigateToNotice(notice.type, notice.id)" v-if="isShowNotice">
      <div class="container">
        <div class="notice-container">
          <span class="iconfont icon-laba-"></span>
          <b class="notice-tag">官方公告</b>
          <span class="notice-title">{{ notice.title }}</span>
          <!-- <span class="notice-time">{{ notice.publish_time | formatTime }}</span> -->
        </div>
        <span class="iconfont icon-guanbi-" @click.stop="closeNotice(notice.type, notice.id)"></span>
      </div>
    </div>
    <div class="gapper" :class="{'is-fixed': isBottom}"></div>
    <div class="top-page">
      <div class="container">
        <div class="banner">
          <banner :items="banners" :itemHeight="'400px'"></banner>
        </div>
        <div class="calendar">
          <calendar
            @setDaysList="getDaysList"
            :list="calendarData"
            :isDisplayOtherMonthDay="true"
            :sundayStart="true"
          ></calendar>
        </div>
      </div>
    </div>
    <div class="search-page">
      <div class="container">
        <search v-if="!$store.state.isMobile" :tags="tags" :curTag="curTag" @select="selectTag"></search>
        <GroupList
          :events="events"
          :branches="branches"
          :pageInfo="pageInfo"
          @getMore="getEventList"
          :isEnd="isEnd"
          :loadingCount="loadingCount"
          :loading="loading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import banner from './picSwipe'
import search from './search'
import GroupList from './confList'
import weixinshare from '@/util/weixinshare'
import calendar from '@/components/vue-calendar'
// import lodash from 'lodash'
import { getBranchAll } from '@/util/methods'
import service from '@/service'
import { month } from './month.js'
import moment from 'moment'
import { mapState, mapMutations } from 'vuex'

// 获取当前月份
// const currentMonth = moment(new Date()).format('MM')

export default {
  data () {
    return {
      banners: [],
      /*
       * structure: http://zentao.geekbang.org/zentao/doc-view-413.html#wow0
       */
      tags: [{
        type_name: '月份',
        type_key: 'month',
        tags: month
      }],
      branches: [],
      /*
       * structure: https://yapi.geekbang.org/project/71/interface/api/935
       */
      curTag: {
        pid: '', // 活动类型
        event_type: '', // 活动类型
        month: '',
        branch_id: ''
      },
      events: [],
      pageInfo: {
        current_page: 1
      },
      calendarData: [],
      notice: {},
      isShowNotice: false,
      // isNoticeFixed: false,
      noticeTop: 0,
      // 正在加载
      loading: false,
      // 数据是否是最后
      isEnd: false,
      // 加载的次数
      loadingCount: 0
    }
  },
  components: {
    banner,
    calendar,
    search,
    GroupList
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin',
      isBottom: 'isBottom'
    }),
    origin () {
      return window.location.origin
    }
  },
  created () {
    // 公告
    service.getNoticeNews().then(data => {
      if (data && typeof data === 'object' && Object.keys(data).length) {
        this.notice = data

        // 判断是否显示公告
        let closeTime = window.localStorage.getItem(`notice`)
        let isTheItemInfo = false

        if (closeTime) {
          let itemInfo = closeTime.split('-')
          let itemInfoIds = itemInfo[0].split('_') || []
          if (itemInfoIds.length && Number(itemInfoIds[0]) === Number(this.notice.type) && Number(itemInfoIds[1]) === Number(this.notice.id)) isTheItemInfo = true

          if (isTheItemInfo) {
            let now = new Date()
            let time = itemInfo[1].split('_')
            if ((Date.parse(now) - Number(time[0])) / 1000 >= 60 * 60 * 24 - 1 || now.getDate() !== Number(time[1])) {
              window.localStorage.removeItem('notice')
              this.isShowNotice = true
            }
          } else {
            window.localStorage.removeItem('notice')
            this.isShowNotice = true
          }
        } else {
          this.isShowNotice = true
        }
      }
    })

    // 热门活动
    // request.get(config.Server + config.API_EVENT_HOTEVENTS)
    service.getHotEvent()
      .then(res => {
        this.banners = res
      })
      .catch(err => { console.log(err) })

    // tags
    Promise.all([getBranchAll(), service.getEventTypes()])
      .then(v => {
        v[0].unshift({ id: 99999, name: '总部' })
        this.branches = v[0]
        this.tags.push({
          type_name: '主办方',
          type_key: 'branch_id',
          tags: v[0]
        })
        this.tags.push({
          type_name: '活动类型',
          type_key: 'event_type',
          tags: v[1].map(item => (
            item.children.length
              ? item.children
              : Object.assign({}, item, { pid: item.id })
          )).flat()
        })
        this.tags.forEach(item => {
          item.tags.unshift({ id: '', name: '全部' })
        })
      })
      .catch(err => {
        console.log(err)
      })
  },
  mounted () {
    weixinshare({
      title: '最新活动 | TGO',
      desc: '通过 10余种多维度的活动形式，深入解读热门话题，丰富行业观察视角，获取实践路径'
    })

    setTimeout(() => {
      const noticeBar = this.$refs.notice
      if (noticeBar) this.noticeTop = noticeBar.getBoundingClientRect().top
    }, 500)

    // this.getEventList({ isCurTagChange: true, pageNum: 1 })

    window.addEventListener('scroll', this.listenerScroll)
    // 监听页面到底操作
    window.addEventListener('scroll', this.onScroll)
  },
  methods: {
    ...mapMutations({
      // 检测是否到底
      setBottom: 'CHECK_BOTTOM'
    }),
    selectTag (type, id, pid) {
      this.loadingCount = 0
      this.isEnd = false
      this.$set(this.curTag, type, id)
      this.$set(this.curTag, 'pid', pid)
    },
    getDaysList (obj) {
      let date = obj.date
      let lists = obj.lists
      // 向后端请求数据
      const year = moment(date).format('YYYY')
      const month = moment(date).format('MM')
      // const dBegin = new Date(year, month, 1)
      // const dEnd = new Date(year, month, new Date(year, month + 1, 0).getDate())
      // const beginTime = Date.parse(dBegin) / 1000
      // const endTime = Date.parse(dEnd) / 1000
      service.getCalendarEvent({ year, month })
        .then((res) => {
          const calendarData = {}
          res.date.forEach(item => {
            calendarData[item.day] = item
          })
          lists.forEach((k, idx) => {
            k.busi = calendarData[k.id] && k.otherMonth === 'nowMonth' ? calendarData[k.id].events : ''
            // 触发 数组更新
            this.$set(k, idx, k)
          })
          this.calendarData = lists
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getEventList (params) {
      // 如果到底直接 return
      if (this.isEnd) return

      service.getEventList({
        ...this.curTag,
        page: params.pageNum,
        size: params.pageSize || 6
      })
        .then((res) => {
          if (!Array.isArray(res.list)) return
          this.pageInfo = res.page
          this.loadingCount++
          this.events = params.isCurTagChange ? res.list : this.events.concat(res.list)
          if (this.pageInfo.total <= (this.pageInfo.current_page * 6)) this.isEnd = true
        })
        .catch((err) => { console.log(err) })
    },
    navigateToNotice (type, id) {
      window.open(`${this.origin}/notice?type=${type}&id=${id}`)
      this.closeNotice(type, id)
      // this.$router.push({ path: 'notice', query: { type, id } })
    },
    closeNotice (type, id) {
      let time = new Date()
      window.localStorage.setItem(`notice`, `${type}_${id}-${Date.parse(time)}_${time.getDate()}`)
      this.isShowNotice = false
    },
    // listenerScroll () {
    //   const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
    //   this.isNoticeFixed = this.isShowNotice && scrollTop >= this.noticeTop
    // },
    // 页面到底操作
    onScroll () {
      const groupScroll = document.querySelector('.right')
      // // 滚动距离
      // const scrollTop = window.pageYOffset
      // 当前可视化区域的距离
      const windowHeight = Math.ceil(window.innerHeight)
      // 当前元素距离底部距离
      const groupHeight = groupScroll.getBoundingClientRect()
      this.setBottom(Number(windowHeight) >= Math.ceil(groupHeight.bottom))
    }
  },
  filters: {
    formatTime: function (publishTime) {
      let time = new Date(publishTime * 1000)
      let y = time.getFullYear()
      let m = time.getMonth() + 1
      let d = time.getDay()
      return `${y} - ${m < 10 ? '0' + m : m} - ${d < 10 ? '0' + d : d}`
    }
  },
  watch: {
    'curTag': {
      handler: function (n, o) {
        this.getEventList({
          isCurTagChange: true,
          pageNum: 1
        })
      },
      deep: true
    },
    'isLogin': {
      handler: function (n, o) {
        if (n) {
          service.getTeamUserInfo()
            .then((data) => {
              if (Object.keys(data).length && data.branch_id) {
                this.curTag.branch_id = data.branch_id
              } else {
                this.getEventList({
                  isCurTagChange: true,
                  pageNum: 1
                })
              }
            })
            .catch(() => {
              this.getEventList({
                isCurTagChange: true,
                pageNum: 1
              })
            })
        } else {
          console.log('333')
          this.getEventList({
            isCurTagChange: true,
            pageNum: 1
          })
        }
      }
    },
    // 判断是否滑动到底部，加载下一页数据
    'isBottom': {
      handler: function (val) {
        console.log('this.loadingCount', this.loadingCount)
        val && !!this.loadingCount && this.loadingCount < 3 && this.getEventList({ isCurTagChange: false, pageNum: ++this.pageInfo.current_page })
      }
    }
  },
  beforeDestroy () {
    // window.removeEventListener('scroll', this.listenerScroll)
    // 销毁监听
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

.page-events
  background-color: #f4f3f3
  .notice
    display: flex
    justify-content: center
    text-align: center
    background-color: $primary3
    height: 44px
    padding: 10px 0
    color: #fff
    cursor: pointer
    &.notice_fixed
      position: fixed
      left: 0
      right: 0
      top: 0
      z-index: 1000
    .container
      position: relative
      display: flex
      .icon-guanbi-
        font-weight: 600
        position: absolute
        right: 20px
    .notice-container
      position: absolute
      // top: 50%
      left: 50%
      transform: translateX(-50%)
      display: flex
      // padding: 10px 0
      // padding-right: 50px
      .iconfont
        flex-shrink: 0
      .notice-tag
        flex-shrink: 0
        position: relative
        font-weight: 400
        padding: 0 13px 0 8px
        margin-right: 13px
        &::after
          position: absolute
          top: 48%
          right: 0
          transform: translateY(-50%)
          content: ''
          width: 1px
          height: 14px
          background: #fff
      .notice-title
        width: max-content
        flex-shrink: 1
        +limit-line-numbers(1)
      .notice-time
        flex-shrink: 0
  .gapper
    height: 30px
    background: #f4f3f3
    &.is-fixed
      margin-top: 44px
  .top-page
    height: 400px
    .container
      display: flex
      justify-content: space-between
      .banner
        width: 66%
        height: 100%
        border-radius: 5px
        overflow: hidden
        +mobile
          height: 80vw
          min-height: auto
      .calendar
        width: 32%
        height: 400px
        border-radius: 5px
        // overflow: hidden
        background-color: #282D32
        +mobile
          height: 80vw
          min-height: auto
  .search-page
    padding-bottom: 80px
    background-color: #f4f3f3
    +mobile
      background-color: #f5f5f5
    .container
      padding-top: 30px
</style>
